import { faCheck } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { cn } from '@pickleballinc/ui/lib/utils';

interface StepProps {
	text: string;
	active: boolean;
	finished: boolean;
	isOrange?: boolean;
	onClick: () => void;
	disabled?: boolean;
}
export function Step({ text, active, finished, isOrange, onClick, disabled }: StepProps) {
	return (
		<div
			onClick={!disabled ? onClick : () => {}}
			className={`relative flex ${disabled ? '' : 'cursor-pointer'} flex-col items-center gap-2 overflow-visible`}
		>
			<div
				className={cn('size-6 border-2 flex items-center justify-center rounded-full', {
					'border-darkorange-600': (active || finished) && isOrange,
					'border-experiment': (active || finished) && !isOrange,
					'bg-darkorange-100': active && !finished && isOrange,
					'bg-experiment/20': active && !finished && !isOrange,
					'bg-white': !active && !finished
				})}
			>
				{finished ? (
					<FontAwesomeIcon
						size="xs"
						icon={faCheck}
						className={`-mb-0.5 animate-fade-in ${isOrange ? '!text-darkorange-600' : 'text-experiment'}`}
					/>
				) : (
					<div
						className={cn('size-2 rounded transition-all animate-fade-in', {
							'bg-darkorange-600': active && isOrange,
							'bg-experiment': active && !isOrange,
							'bg-gray-200': !active
						})}
					/>
				)}
			</div>
			<span
				className={cn('whitespace-nowrap absolute -bottom-[120%] text-center text-[12px] md:text-sm font-semibold', {
					'text-darkorange-600': active && isOrange,
					'text-experiment': active && !isOrange
				})}
			>
				{text}
			</span>
		</div>
	);
}
